module.exports = {
  "dof-col": {
    "flex": 1,
    "flexDirection": "column"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-12b7775d!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-col/index.vue
// module id = 423
// module chunks = 0 1